import { DocumentFormBlock } from '~/core/shared/types';

export const blockMatchesSearch = (
  block: DocumentFormBlock,
  searchTerm: string,
): boolean =>
  block.meta?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false;
